'use strict';

// if ($('#js-customize-page').length) {
var customize = function () {
    var selectProduct = $('#product'),
        selectPieces = $('#pieces'),
        color = $('.customize__color');

    function checkPieces(option) {
        var pieces = option.attr('data-pieces');
        selectPieces.find('#pieces-12').prop('disabled', pieces == "-12");
        $('#pieces-more-12').prop('selected', pieces == "-12");
    }

    function checkColors(option) {
        var str_colors = option.attr('data-exclude-colors');
        var colors = str_colors.split(',');

        $('.customize__color').removeClass('hide');

        $.each(colors, function (index, color) {
            $('#' + color).parent().addClass('hide');
        });

        $('.customize__color').not('.hide').first().find('input').prop('checked', true);
    }

    return {

        productSelection: function productSelection() {
            $('#product').change(function () {
                var option = $(this).children("option:selected");

                checkPieces(option);
                checkColors(option);
            });
        },
        resetButton: function resetButton() {
            $('#button-reset').click(function () {
                $('body, html').animate({
                    scrollTop: $('.customize__content').offset().top - $('#shopify-section-header').height()
                }, 500);
            });
        },

        init: function init() {
            checkColors($('#product').children("option:selected"));
            this.productSelection();
            this.resetButton();
        }
    };
}();

$(document).ready(function () {
    if ($('#js-customize-page').length) {
        customize.init();
    }
});
// }
"use strict";

function resizeHomeButtons() {
  $("#btn-brief").width($("#btn-brief-reference").width());
}

$(document).ready(function () {
  $(".js-mobile-nav-toggle").click(function () {
    if (!$(this).hasClass("mobile-nav--open")) {
      $(".mobile-nav-wrapper").css({
        top: $(".announcement-bar").outerHeight()
      });
    }
  });
  setTimeout(function () {
    $(".bc-sf-search-btn-close-suggestion").click(function () {
      $("body").removeClass(".js-drawer-open");
    });
  }, 3000);
});